// extracted by mini-css-extract-plugin
export var menu = "mobile-menu-module--menu--28tVE";
export var menu_item = "mobile-menu-module--menu_item--1NrPx";
export var menu_buttons = "mobile-menu-module--menu_buttons--FuVH0";
export var soon = "mobile-menu-module--soon--uIVmV";
export var listItem = "mobile-menu-module--listItem--3wXK0";
export var groupName = "mobile-menu-module--groupName--39ESB";